import { render, staticRenderFns } from "./TagCreate.vue?vue&type=template&id=561a91a6"
import script from "./TagCreate.vue?vue&type=script&lang=js"
export * from "./TagCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports